import { apiFetch } from './api';

/**
 * Get Xero authorization URL
 */
export function connectXero() {
  return apiFetch('/api/admin/xero/connect', {
    method: 'POST'
  });
}

/**
 * Get Xero connection status
 */
export function getXeroStatus() {
  return apiFetch('/api/admin/xero/status');
}

/**
 * Disconnect Xero
 */
export function disconnectXero() {
  return apiFetch('/api/admin/xero/disconnect', {
    method: 'POST'
  });
}

/**
 * Get chart of accounts
 */
export function getAccounts() {
  return apiFetch('/api/admin/xero/accounts');
}

/**
 * Get tax rates
 */
export function getTaxRates() {
  return apiFetch('/api/admin/xero/tax-rates');
}

/**
 * Update Xero configuration
 */
export function updateXeroConfig({ accountCode, taxRateCode, bankAccountCode }) {
  return apiFetch('/api/admin/xero/config', {
    method: 'PUT',
    body: { accountCode, taxRateCode, bankAccountCode }
  });
}

/**
 * Manual sync trigger
 */
export function syncToXero() {
  return apiFetch('/api/admin/xero/sync', {
    method: 'POST'
  });
}

/**
 * List connected Xero organisations (tenants)
 */
export function getXeroOrganizations() {
  return apiFetch('/api/admin/xero/organizations');
}

/**
 * Activate a specific tenant so accounts/tax rates/invoice sync uses it
 */
export function activateXeroOrganization({ tenantId }) {
  return apiFetch('/api/admin/xero/activate', {
    method: 'POST',
    body: { tenantId }
  });
}


